import { generatePath, Navigate, useParams } from "react-router-dom";
import { USER_SERVICE_CHARGES_INVOICES_PATH } from "../../../paths";

export const UserServiceChargesPage = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/" />;
  }

  return <Navigate to={generatePath(USER_SERVICE_CHARGES_INVOICES_PATH, { id })} />;
};
